<template>
  <nav class="header">
    <div>
      <ul class="flex nav nav-pills">
        <li :class="['nav-item app-logo']">
          <a href="#studios" id="studios-tab" :class="{ 'active': fit20.selectTabId == 'tab_id0' }">
            <img :src="fit20.storageBaseUrl + '/static/images/fit20-logo.png'" />
          </a>
        </li>
        <li class="nav-item burger" @click="openMenu()">
          <div class="burger-div" id="">
            <img :src="fit20.storageBaseUrl + '/static/images/hamburger-menu.svg'" />
          </div>
        </li>
      </ul>
    </div>
    <!-- start the side menu -->
    <div v-if="showMenu" class="side-menu">
      <div class="menu-header flex">
        <div><img width="40" :src="getUserPhoto()" /></div>
        <div class="trainer-name">
          <div>{{ getUserName() }}</div>
          <div>{{ fit20.user.email }}</div>
        </div>
        <div class="close" @click="openMenu()"><img width="20"
            :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'" />
        </div>
      </div>
      <div class="menu-items">
        <div v-if="fit20.user.role == 'super_admin' && fit20.user.email === 'mohammaddarwesh@fit20.com'"
          @click="usersPopup">users</div>
        <div @click="signOut()">logout</div>
      </div>
    </div>
    <!-- start the side menu -->
    <Users v-if="showUsersPopup" :fit20="fit20" :usersPopup="usersPopup">
    </Users>
  </nav>
</template>
<script>
import Users from "./Users.vue";
import isEqual from 'lodash/isEqual';

export default {
  name: 'Header',
  components: {
    Users,
  },
  props: ["fit20", "signOut"],
  data() {
    return {
      showMenu: false,
      showUsersPopup: false,
    };
  },
  methods: {
    openMenu: function () {
      this.showMenu = !this.showMenu;
    },
    usersPopup: function () {
      this.showUsersPopup = !this.showUsersPopup;
      this.showMenu = false;
      // if (!isEqual(this.fit20.users, this.fit20.originalUsers)) {
      //   this.fit20.users = this.fit20.originalUsers;
      //   console.log('not equal');
      // }

    },
    getUserPhoto: function () {
      if (localStorage.getItem('user-picture')) {
        return localStorage.getItem('user-picture');
      }
      return 'https://storage.googleapis.com/fit20app-4-acctest.appspot.com/user/default.svg';
    },
    getUserName: function () {
      if (localStorage.getItem('user-name')) {
        return localStorage.getItem('user-name');
      }
      return "";
    },
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    newSession: function (tab) {
      this.fit20.tabs[tab]['active'] = true;
      this.fit20.tabs[tab]['action'] = 'new session';
      console.log(this.fit20.tabs);
    },
    cancelSession: function (tab) {
      this.fit20.tabs[tab]['active'] = false;
      this.fit20.tabs[tab]['action'] = 'cancel';
      console.log(this.fit20.tabs);
    },
    saveSession: function (tab) {
      this.fit20.tabs[tab]['active'] = false;
      this.fit20.tabs[tab]['action'] = 'save';
      console.log(this.fit20.tabs);
    },
    partnersNames: function (member) {
      console.log('get partners names');
      if (member) {
        const names = [];
        let currentStudio = member.studios.find(studio => studio.id == this.fit20.studio.id);
        if (currentStudio) {
          currentStudio.partners.forEach(partner => {
            let existPartner = this.fit20.studio.members.find(member => member.id == partner.id);
            if (existPartner && existPartner.firstName) {
              names.push(existPartner.firstName);
            }
          })
        }
        return names;
      } else {
        return "";
      }

    },
    closeTap: function (tabNum) {
      console.log(tabNum);
      this.fit20.currentMembers[tabNum] = [];

      this.selectTab('tab_id' + (tabNum + 1), 'tab_id1');
      console.log(this.fit20.currentMembers);
    }
  },
  computed: {
    memberSince: function () { },
  },
  mounted: function () { },

};
</script>
<style>
.header {
  height: 60px;
  border-bottom: solid 2px var(--fit20-lighter-gray);
  position: relative;
}

.nav-pills {
  margin-top: 10px;
}

.flex .justify-content {
  justify-content: space-around;
}

.app-logo {
  width: 28%;
}

.app-logo.selected-nav-item {
  width: 41% !important;
  background: white;
}

.app-logo img {
  height: 58px;
  margin-bottom: 15px;
  position: absolute;
  top: 0;
}

.nav-item {
  height: 62px;
  /* border-bottom: solid 2px var(--fit20-lighter-gray); */
  /* border-left: solid 2px var(--fit20-lighter-gray); */
  transition: all .4s;
}


.nav-item a {
  display: inline-block;
  height: 95%;
  width: 100%;
  color: var(--fit20-lighter-gray);
  border-left: solid 2px var(--fit20-lighter-gray);
  /* margin-left: 10px; */
}

.selected-nav-item {
  width: 25% !important;
  border-bottom: solid 2px transparent;
  background: white;
  transition: all .4s;
}

.selected-nav-item a.active {
  color: var(--fit20-gray);
  border-left: solid 2px var(--fit20-green);
  background: white;
  transition: all .4s;
}

.tabs {
  width: 12.25%;
  position: relative;
}

.tabs>a>div {
  padding-left: 10px;
}

.gray::before {
  content: "";
  position: absolute;
  top: 20%;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: var(--fit20-lighter-gray);
  transition: background-color 0.5s;
}

.green::before {
  content: "";
  position: absolute;
  top: 20%;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: var(--fit20-green);
  transition: background-color 0.5s;
}

.burger {
  width: 10%;
  margin-left: auto;
}

.burger-div {
  text-align: right;
  padding-right: 15px;
  /* padding-top: 5px; */
}

.burger img {
  width: 45px;
}

.dynamic-btn {
  margin-top: 10px;
  animation: appear-main .6s;
}

.close-btn {
  margin-right: 10px;
  animation: appear-main .6s;
}

@keyframes appear-main {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes menu-animation {
  from {
    width: 0;
  }

  to {
    width: 40%;
  }
}

.header .side-menu {
  width: 40%;
  position: fixed;
  top: 10px;
  right: 10px;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  background-color: white;
  z-index: 10;
  padding: 10px 5px 0px 5px;
  animation: menu-animation .6s;
}

.menu-header .close {
  /* justify-content: space-between; */
  position: absolute;
  right: 8px;
  top: 20px;
}

.trainer-name {
  padding-left: 10px;
  color: var(--fit20-green);
}

.menu-items {
  margin-top: 15px;
  margin-left: 50px;
}

.menu-items div {
  margin-bottom: 8px;
  color: var(--fit20-gray);
}

.sensor-icon {
  text-align: right;
}
</style>
